<template>
  <div class="top-bar-comp">
    <div class="navbar-collapse navbar-main">
      <ul class="navbar-left pull-left">
        <li class="cursor-default">Welcome to Onelink Plus</li>
        <li class="cursor-default">Hotline: <span class="txt-white">+86 400-800-6116</span></li>
      </ul>
      <!--  未登录  -->
      <ul class="navbar-right pull-right" v-if="isLogin == ''">
        <li class="cursor-pointer" @click="goToHref('/loginEn')">Login</li>
        <li style="cursor: default;">Not yet joined? Please Contact Customer Support</li>
      </ul>
      <!--  已登录  -->
      <ul class="navbar-right pull-right" v-if="isLogin == '100'">
        <li class="cursor-pointer" @click="goToBidding">Bidding System</li>
        <!--   消息    -->
        <li class="iconBadge">
          <el-dropdown @visible-change="showInfoFn" placement="bottom-start">
            <p class="menu-title" @click="goToHrefAndVerify('/messageNotificationEn')" id="showInfo">Messages
<!--              <span class="badge">{{messageNumber}}</span>-->
              <span v-if="messageNumber">({{messageNumber}})</span>
            </p>
            <el-dropdown-menu slot="dropdown" class="iconBadgeDrop">
              <div class="iconDrop">
                <ul>
                  <li v-for="(message,index) in messageData"
                      :key="index"
                      @click="jumpUrl(message)">
                    <p>{{message.title}}</p>
                    <span>{{message.createTime|time}}</span>
                  </li>
                </ul>
                <a @click="goToHrefAndVerify('/messageNotificationEn')">More>></a>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <!--   用户    -->
        <li class="userInfo">
          <!-- 第六步给的提示 国际版目前没有 -->
<!--          <transition name="el-fade-in">-->
<!--            <div class="purchaserLeadStep" v-show="leadSteps.sixthStep">-->
<!--              <p>个人中心中，可切换用户所在企业，查看企业管理员，或点击用户头像修改个人信息</p>-->
<!--              <el-button @click.stop="topLeadTy('sixthStep','maskStep')">立即体验</el-button>-->
<!--              <div class="leadArrowDown">-->
<!--                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--          </transition>-->
          <el-dropdown @visible-change="isShowBusiness">
            <p class="menu-title has-leaf">
              {{userInfo.trueName|substr}}<i class="el-icon-arrow-down el-icon--right" style="color: #ccc;"></i>
            </p>
            <el-dropdown-menu slot="dropdown" class="userInfoDrop">
              <!--  切换企业  -->
              <div class="media">
                <div class="media-left">
                  <a @click="goToHref('/personalCenterEn')">
                    <span class="media-object img-circle">
                      <img :src="userInfo.faviconFileDto && userInfo.faviconFileDto.fileUrl || 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/userImage.png'" alt="...">
                    </span>
                    <img class="userIcon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/user_icon01.png" alt="..."  v-if="userInfo.userTag==20">
                    <img class="userIcon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/%E4%BE%9Bicon.png" alt="..." v-if="userInfo.userTag==10">
                  </a>
                </div>
                <div class="media-body media-middle">
                  <h4 class="media-heading" style="line-height: 1.3;">
                    <span @click="goToHref('/personalCenterEn')" :title="userInfo.trueName">{{userInfo.trueName}}</span>
                    <span class="setUser" @click="goToHref('/personalCenterEn')"></span>
                    <a @click="loginOut()" class="pull-right logout">Log out</a>
                  </h4>
                  <p class="clearfix">
                    <span class="company-name" :title="userInfo.companyName">{{userInfo.companyName}}</span>
                    <a class="businessChange pull-right" @mouseenter="showBusinessFn">Change Company</a>
                    <transition name="el-zoom-in-top">
                      <div class="userInfoDrop businessDrop" v-show="showBusiness">
                        <el-radio-group v-model="userInfo.companyId" @change="handleCommand">
                          <el-radio v-for="(org,index) in userInfo.orgs" :key="index" :label="org.orgId">
                            <el-dropdown-item><span>{{org.orgName}}</span></el-dropdown-item>
                          </el-radio>
                        </el-radio-group>
                      </div>
                    </transition>
                  </p>

                  <!--  管理员  -->
                  <p class="clearfix">
                    <a class="businessChange" @mouseenter="showManagerFn">Administrator</a>
                    <transition name="el-zoom-in-top">
                      <div class="userInfoDrop managerDrop" v-show="showManager">
                        <ul v-show="memUserDtos.length>0">
                          <li class="clearfix" v-for="(menuUser,index) in memUserDtos" :key="index"><span class="pull-left">{{menuUser.trueName}}</span> <span class="emailSpan">{{menuUser.email}}</span></li>
                        </ul>
                        <span v-show="memUserDtos.length<=0">No administrator, please contact C/S（400-108-6116）</span>
                      </div>
                    </transition>
                  </p>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>

    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import Cookies from 'js-cookie'
  export default {
    data () {
      return {
        isLogin: '',  // 登录状态
        refSysId: '',
        messageNumber: '',  // 未读消息
        userInfo: {},  // 用户信息
        showBusiness: false,  // 展示企业
        showManager: false,  //展示管理员列表
        memUserDtos: [],  // 管理员
        messageData: []  // 消息列表
      }
    },
    computed: mapState([
      'KP'
      // 'leadSteps'
    ]),
    created () {
      this.isLogin = this.getToken('isLogin');
      if(this.isLogin == '100'){
        let messageNumber = this.getDAesString(this.getToken('messageNumber'),this.KP.key,this.KP.iv);
        this.messageNumber = Number(messageNumber) > 99 ? '99+': Number(messageNumber)
        let loginInfo = JSON.parse(this.getDAesString(this.getToken('loginInfo'),this.KP.key,this.KP.iv) || '{}')
        this.userInfo = loginInfo.uCenterMemberInforDto || {}
        this.refSysId = loginInfo.refSysId
      }
    },
    methods:{
      async goToHrefAndVerify (val) {
        await this.$store.dispatch('findWebDtoHandler');
        this.$store.dispatch('informationCompletion', () => {
          this.$router.push({path: val})
        });
      },

      goToBidding () {
        let url = window.location.href;
        let env = (/local.onelinkplus.com/.test(url) || /test/.test(url) ? "test-ebidding" : /uat/.test(url) ? "uat-ebidding" : "ebidding");
        location.href = `http://${env}.onelinkplus.com/epl/pur/exeplan/queryExeplan.htm?locale=en_US`
      },

      goToHref(path){
        this.$router.push({path})
      },

      showBusinessFn(){
        this.showBusiness=true;
        this.showManager=false;
      },

      isShowBusiness(){
        this.showBusiness = false;
        this.showManager = false;
      },

      // 获取未读消息列表
      showInfoFn () {
        this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
          isFinish:0,
          pageNo:1,
          pageSize:4
        }).then((res) => {
          let data = res.data;
          let messageData = data.queryTodoResponse.list;
          let noticeData = data.queryNotifyResponse.list;
          if(Object.keys(noticeData).length > 0 && messageData.length < 4){
            messageData = messageData.concat(noticeData);
          }
          this.messageData = messageData
          this.messageNumber = Number(data.messageNumber) > 99 ? '99+': Number(data.messageNumber)
          this.setToken('messageNumber', this.getAesString(data.messageNumber, this.KP.key, this.KP.iv));
        }).catch((err) => {
          console.log(err)
        })
      },

      // 获取管理员列表
      showManagerFn(){
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectOrgManager?orgId='+this.userInfo.companyId, {
        }).then((res) => {
          this.memUserDtos = res.data;
          this.showManager=true;
          this.showBusiness=false;
        }).catch((err) => {
          console.log(err)
        })
      },

      // 登录失败 1.该账户正在审核中 2. 该账户审批未通过
      goRegisterError (userInfo, type) {
        let queryInfo = {
          userId: userInfo.id,
          email: userInfo.email,
          companyId: userInfo.companyId,
          companyName: userInfo.companyName,
          orgIdentity: userInfo.orgIdentity,
          regAddrType: userInfo.regAddrType,
          createUserId: userInfo.createUserId
        }

        if (type == 1) {
          this.$router.push({
            path:"registerExamine",
            query:{
              ...queryInfo,
              trueName: userInfo.trueName,
            }
          });
          return false
        }

        if (type == 2) {
          this.$router.push({
            path:"registerFailed",
            query:{
              ...queryInfo,
              regeisterType: data.registerType,
              exmaineMessage: data.checkCardInfo && data.checkCardInfo.checkRemark
            }
          });
          return false
        }
      },

      // 切换企业
      handleCommand(command) {
        this.$axios.post('/onelink.mdata.main.api/user/switvhCompany', {
          userId: this.userInfo.id,
          rememeberPassword: true,
          companyId: command
        }).then((res) => {
          let data = res.data;
          let loginFlag = data.loginFlag;
          this.userInfo = data.uCenterMemberInforDto;
          this.setToken('loginInfo', this.getAesString(JSON.stringify(data || {}), this.KP.key, this.KP.iv));
          this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
          this.setToken('companyInfo',this.getAesString(JSON.stringify(data.uCenterMemberInforDto.uCenterORGUserRelationsDto || {}),this.KP.key,this.KP.iv));

          // 目前不知道干啥用
          // let checkIsWanbangGroup = data.checkIsWanbangGroup;
          // if(checkIsWanbangGroup){
          //   this.setToken('checkIsWanbangGroup',this.getAesString("0",this.KP.key,this.KP.iv));
          // }else{
          //   this.setToken('checkIsWanbangGroup',this.getAesString("1",this.KP.key,this.KP.iv));
          // }
          if(loginFlag){
            // 不知道什么时候用  国际化用到再存吧
            // if(data.coordinationSupplierAuthFlag){
            //   this.setToken('coordinationSupplierAuthFlag','100');
            // }else{
            //   this.setToken('coordinationSupplierAuthFlag','200');
            // }
            // if(data.coordinationSystemAuthFlag){
            //   this.setToken('coordinationSystemAuthFlag','100')
            // }else{
            //   this.setToken('coordinationSystemAuthFlag','200')
            // }
            // if(data.supplierManagerAuthFlag){
            //   this.setToken('supplierManagerAuthFlag','100')
            // }else{
            //   this.setToken('supplierManagerAuthFlag','200')
            // }
            // 国际化用到再存
            // let checkFlag = data.checkFlag;
            // if(checkFlag){
            //   this.setToken('checkFlag',100);
            //   Cookies.set('checkFlag',100,{domain:'.onelinkplus.com'});
            // }else{
            //   this.setToken('checkFlag',200);
            //   Cookies.set('checkFlag',200,{domain:'.onelinkplus.com'});
            // }
            this.setToken('exmaineMessage','');
            Cookies.set('exmaineMessage','',{domain:'.onelinkplus.com'});
            this.$router.go(0);
          } else {
            if(data.errorInfo == '该账户正在审核中'){
              this.setToken('examineStatus',200);
              Cookies.set('examineStatus',200,{domain:'.onelinkplus.com'});
              this.$message.type('This account is under review');
              this.goRegisterError(this.userInfo, 1)
            }else if(data.errorInfo == '该账户审批未通过'){
              this.setToken('examineStatus',300);
              this.setToken('exmaineMessage', data.checkCardInfo.checkRemark);
              Cookies.set('examineStatus',300,{domain:'.onelinkplus.com'});
              Cookies.set('exmaineMessage', data.checkCardInfo.checkRemark,{domain:'.onelinkplus.com'});
              this.$message.type('The account approval failed');
              this.goRegisterError(this.userInfo, 2)
            }else{
              // 用户名和密码不符
              this.$message.error('Your password is incorrect');
            }
          }

        }).catch((err) => {
          console.log(err)
        })
      },

      // 退出
      loginOut(){
        this.$axios.post('/onelink.mdata.main.api/user/loginOut', {
        }).then((res) => {
          let data = res.data;
          let logoutFlag = data.loginOutFlag;
          if(logoutFlag){
            // 记住密码 退出也不能删 重新存一下
            let rememberInfo = this.getToken('rememberInfo')
            let isRemember = this.getToken('isRemember')
            localStorage.clear()
            this.setToken('isRemember', isRemember)
            this.setToken('rememberInfo', rememberInfo)
            // this.removeToken('isLogin');
            // this.removeToken('userInfo');
            // this.removeToken('companyInfo');
            // this.removeToken('checkFlag');
            // this.removeToken('examineStatus');
            // this.removeToken('exmaineMessage');
            // this.removeToken('userTag');
            // this.removeToken('coordinationSupplierAuthFlag');
            // this.removeToken('coordinationSystemAuthFlag');
            // this.removeToken('supplierManagerAuthFlag');
            // this.removeToken('privacyPolicyFlag');
            Cookies.remove('isLogin');
            // Cookies.remove('checkFlag');
            // Cookies.remove('examineStatus');
            // Cookies.remove('exmaineMessage');

            this.$router.push({path:'/loginEn'})
          }
        }).catch((err) => {
          console.log(err)
        })
      },

      /*
      *   消息跳转
      *  1. 判断账号的有效状态
      *  2. 判断是否是变更状态
      *  3. 判断信息是否完善
      *  4. 账号状态ok 判断跳转地址是站内还是站外 站外需区分供应商管理和ep.fosunproperty.com
      * */
      async jumpUrl(item){
        try {
          await this.$store.dispatch('findWebDtoHandler');
        } catch (e) {}
        if (this.getToken('examineStatus') == '200'){
          this.goRegisterError(this.userInfo, 1)
        } else if(this.getToken('examineStatus') == '300'){
          this.goRegisterError(this.userInfo, 2)
        } else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
          this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
        } else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
          this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
            cancelButtonClass:'cancelBtn',
            customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              let data = res.data;
              this.removeCookie('TALK_LATER_' + data.userId);
              this.setCookie('TALK_LATER_' + data.userId, data.instanceDay);
            });
          });
        } else {
          if(typeof(item.url) == "undefined") {
            this.$axios.post('/onelink.mdata.main.api/message/markRead', {
              id: item.id
            }).then((res) => {
              this.$router.push({path:'/messageNotificationDetails',query:{noticeId: item.id}})
            }).catch((err) => {
              console.log(err)
            })
          } else {
            if(item.productLine == '供应商管理'){
              window.location.href = item.url + item.isFinish + "&Id=" + item.id;
            } else {
              if(item.url.indexOf("ep.fosunproperty.com") > 0) {
                let foSunUrl = "https://ep.fosunproperty.com:8888/";
                let userSsoToken = Cookies.get("user_sso_token");
                let guid = this.getUrlKey('guid',"?" + item.url.split("?")[1])
                let openUrl = foSunUrl  +"Interface/YiLianAction.aspx?action=centerPage&token=" + userSsoToken + "&pguid="+ this.refSysId+"&language=en_CN";
                window.location.href = openUrl;
              } else if(item.url.indexOf("?")>0){
                window.location.href = item.url + "&todoId=" + item.id;
              } else{
                window.location.href = item.url + "?todoId=" + item.id;
              }
            }
          }
        }
      },

      // 在线客服
      goCustomerService() {
        window.open('https://onelinkplus.udesk.cn/im_client/?web_plugin_id=52506&cur_title=%E4%B8%80%E9%93%BE%E7%BD%91&src_url=&cur_url=http%253A%252F%252Fex.onelinkplus.com%252Fportal%252Findex&pre_url=http%3A%2F%2Fex.onelinkplus.com%2Fportal%2Findex')
      }
    }
  }
</script>

<style lang="stylus">
  .top-bar-comp {
    width: 100%;
    position: fixed;
    z-index: 1051;
    top: 0px;
    height: 32px;
    background: #212933;
    font-size: 12px;
    color: #C4C8CE;
    .navbar-main{
      max-width: 1200px;
      margin: auto;
    }
    .navbar-left>li, .navbar-right>li {
      float: left;
      position relative
      line-height: 32px;
      padding: 0 16px;
      cursor:pointer;
      &:hover{
        background-color: #373E48;
        .menu-dropdown{
          opacity: 1;
          z-index: 1;
          top: 31px;
          transition: opacity .3s;
        }
      }
      &:after{
        position absolute;
        content: '';
        top: 10px;
        right: 0;
        width: 1px;
        height: 12px;
        background-color: #606266;
      }
      &:last-child{
        &:after{
          display: none;
        }
      }
    }
    .navbar-right{
      color: #fff;
    }
    .menu-title{
      color: #fff;
      font-size: 12px;
    }
    .has-leaf .el-icon-arrow-down{
      transition: 0.3s;
    }
    .has-leaf:hover .el-icon-arrow-down{
      transform: rotate(-180deg);
      transition: 0.3s;
    }
    .user-avator{
      position: relative;
      display:block;
      width: 64px;
      height: 64px;
      .userIcon{
        position: absolute;
        width: 24px;
        right: -10px;
        top: 0px;
      }
    }
    .user-info{
      margin-left: 80px;
      h5{
        line-height: 1.3;
        font-size: 16px;
        color: #303133;
        margin-top: 5px;
        margin-bottom: 0;
      }
      .layout{
        font-size: 12px;
        color: #A8ACB2;
      }
      .company{
        color: #303133;
        height: 32px;
        line-height: 32px;
      }

      .administrator{
        line-height: 1.5;
      }
      .set-user {
        display inline-block;
        width: 16px;
        height: 16px;
        background: url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/setUser.png") no-repeat center;
        &:hover {
          background: url("https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/setUser_hover.png") no-repeat center;
        }
      }
    }

    .menu-dropdown{
      opacity: 1;
      top: 31px;
      position: absolute;
      right: -10px;
      z-index: -5;
      width: 320px;
      height: 140px;
      background-color: #fff;
      padding: 38px 16px 20px;
      transition: opacity .3s;
    }

    .txt-white{
      font-size: 14px;
      color: #FFFFFF;
    }

    .text-blue{
      color: #3F88E0;
    }
    .overflow-ellipsis {
      max-width: 104px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
    }
    p{
      margin: 0;
    }
    a:hover{
      text-decoration: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/topBarEn/index.vue